import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";

import { formatEstado, formatEstados } from "../../../utils/estados";

import { Inputt, SelectSearch } from "../../../components";

import { groupedPermissions, changeRole, changePermission } from "../handlers";

import {
  getPermissionsForm,
  changeRolePermissions,
  initialState,
  onChange,
  saveElement,
  changeCheckPermission,
} from "./handlers";
import ButtonAdmin from "../ButtonAdmin";
import CardAdmin from "../CardAdmin";

const RolesPermissionForm = ({ stateContext, dataContext, show }) => {
  if (!show) return null;

  const { state, setState } = stateContext;
  const { loading, role, permission } = state;

  const { data, setData } = dataContext;
  const { roles, permissions } = data;

  const [permissionsForm, setPermissionsForm] = useState(null);

  const [permissionRolForm, setPermissionRolForm] = useState({
    ...initialState,
  });

  useEffect(() => {
    setPermissionsForm(getPermissionsForm(permissions, role));

    if (!role) {
      setPermissionRolForm((state) => ({
        ...state,
        role: { ...initialState.role },
      }));
    }

    if (!permission) {
      setPermissionRolForm((state) => ({
        ...state,
        permission: { ...initialState.permission },
      }));
    }
  }, [state, data]);

  const permissions_groups = groupedPermissions(permissionsForm);
  const grupos = permissions_groups && Object.keys(permissions_groups);

  const selectElement = (rol, action) => {
    const callBack = (element, key) => {
      setPermissionRolForm((state) => ({
        ...state,
        [key]: {
          id: element.id,
          name: element.name,
          description: element.description,
          edit: true,
        },
      }));
    };

    if (action === "role") {
      setPermissionRolForm({ ...initialState });
      changeRole(rol, roles, setState, callBack);
    }

    if (action === "permission") {
      setPermissionRolForm({ ...initialState });
      changePermission(rol, permissions, setState, callBack);
    }
  };

  return (
    <>
      <div className="d-flex gap-2 m-0">
        <div className="col-6 p-3 border rounded">
          <h5>Configuración del Rol</h5>
          <div className="row m-0">
            <SelectSearch
              className={{
                container: "col-12 col-lg-10",
                label: `form-label`,
              }}
              isClearable
              id="role"
              value={formatEstado(role)}
              //   onChange={selectElement}
              onChange={(rol) => selectElement(rol, "role")}
              disabled={loading}
              label="Seleccione un Rol"
              options={formatEstados(roles)}
            />

            <ButtonAdmin
              disabled={!role || loading}
              hidden={loading}
              endContent={loading && <Spinner style={{ height: "18px", width: "18px" }} />}
              onClick={() => changeRolePermissions(role, permissionsForm, setState, setData)}
            >
              GUARDAR
            </ButtonAdmin>
          </div>

          <hr />

          {/* Formulario de ROL */}
          <div className="row m-0 mb-3 gap-3">
            <Inputt
              className={{
                container: "col-12 my-auto",
                label: `form-label ${false && "invalid"}`,
                input: `form-control form-control-sm ${false && "invalid"}`,
              }}
              label="Nombre"
              name="role_name"
              disabled={loading}
              value={permissionRolForm.role.name}
              onChange={(e) => onChange(e, setPermissionRolForm)}
            />
            <Inputt
              className={{
                container: "col-12 my-auto",
                label: `form-label ${false && "invalid"}`,
                input: `form-control  form-control-sm ${false && "invalid"}`,
              }}
              label="Descripción"
              name="role_description"
              disabled={loading}
              value={permissionRolForm.role.description}
              onChange={(e) => onChange(e, setPermissionRolForm)}
            />

            <ButtonAdmin
              disabled={
                permissionRolForm.role.name == "" ||
                permissionRolForm.role.description == "" ||
                loading
              }
              hidden={loading}
              endContent={loading && <Spinner style={{ height: "18px", width: "18px" }} />}
              onClick={() =>
                saveElement(
                  permissionRolForm,
                  setData,
                  setState,
                  "role",
                  permissionRolForm.role.edit
                )
              }
            >
              {permissionRolForm.role.edit ? "MODIFICAR" : "AGREGAR"}
            </ButtonAdmin>
          </div>
        </div>
        <div className="col-6 p-3 border rounded">
          <h5>Configuración del Permiso</h5>
          <div className="row m-0">
            <SelectSearch
              className={{
                container: "col-12 col-lg-10",
                label: `form-label`,
              }}
              isSearchable
              isClearable
              id="permission"
              value={formatEstado(permission)}
              //   onChange={selectElement}
              onChange={(permission) => selectElement(permission, "permission")}
              disabled={loading}
              label="Seleccione un Permiso"
              options={formatEstados(data.permissions)}
            />

            <ButtonAdmin
              disabled={!role || loading}
              hidden={loading}
              endContent={loading && <Spinner style={{ height: "18px", width: "18px" }} />}
              onClick={() => changeRolePermissions(role, permissionsForm, setState, setData)}
            >
              GUARDAR
            </ButtonAdmin>
          </div>

          <hr />

          {/* Formulario de Permiso */}
          <div className="row m-0 mb-3 gap-3">
            <Inputt
              className={{
                container: "col-12 my-auto",
                label: `form-label ${false && "invalid"}`,
                input: `form-control  form-control-sm ${false && "invalid"}`,
              }}
              label="Nombre"
              name="permission_name"
              disabled={loading}
              value={permissionRolForm.permission.name}
              onChange={(e) => onChange(e, setPermissionRolForm)}
            />
            <Inputt
              className={{
                container: "col-12 my-auto",
                label: `form-label ${false && "invalid"}`,
                input: `form-control  form-control-sm ${false && "invalid"}`,
              }}
              label="Descripción"
              name="permission_description"
              disabled={loading}
              value={permissionRolForm.permission.description}
              onChange={(e) => onChange(e, setPermissionRolForm)}
            />

            <ButtonAdmin
              disabled={
                permissionRolForm.permission.name == "" ||
                permissionRolForm.permission.description == "" ||
                loading
              }
              hidden={loading}
              endContent={loading && <Spinner style={{ height: "18px", width: "18px" }} />}
              onClick={() =>
                saveElement(
                  permissionRolForm,
                  setData,
                  setState,
                  "permission",
                  permissionRolForm.permission.edit
                )
              }
            >
              {permissionRolForm.permission.edit ? "MODIFICAR" : "AGREGAR"}
            </ButtonAdmin>
          </div>

          {!!state.permission?.roles?.length && (
            <>
              {state.permission.roles.map((r) => (
                <span
                  key={r.id}
                  role="button"
                  className={`me-2 badge bg-success ${r.id === role?.id ? "disabled" : ""}`}
                  onClick={() =>
                    setState((state) => ({
                      ...state,
                      role: r,
                    }))
                  }
                >
                  {r.description}
                </span>
              ))}
            </>
          )}
        </div>
      </div>

      <hr className="my-4" />

      <CardAdmin
        grupos={grupos}
        permissions_groups={permissions_groups}
        role={role}
        loading={loading}
        changeCheckPermission={changeCheckPermission}
        permissionsForm={permissionsForm}
        setPermissionsForm={setPermissionsForm}
      />
    </>
  );
};

export default RolesPermissionForm;
